
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Contact from '@/extend/classes/Contact';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeContact' })

export default class storeContact extends VuexModule {
  // States
  private reccords: Contact[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get contactLoading (): boolean {
    return this.dataLoading;
  }
  private get contactRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get contactLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewContact() {
    return (): Contact => { 
      return this.getContact(0, true);
    }
  }

  
  public get getContact () {
    return (id: number, canCreate = false): Contact => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Contact can't be 0")
        return new Contact();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Contact();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Contact.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromContact(data.reccords[0] as Contact);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listContact (): Contact[] {
    return this.reccords;
  }

  public get listConfigContact (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mContactRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mContactClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mContactLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mContactLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Contact.fromJson(reccord as Contact));
    })
    Contact.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mContactConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mContactCreated (obj: Contact): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareContact(obj)) {
          api.fromContact(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareContact(obj)) {
            api.fromContact(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mContactUpdated (obj: Contact): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareContact(obj)) {
          api.fromContact(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mContactDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerContact (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.contactRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerContact(this.contactCreated, this.contactUpdated, this.contactDeleted);
          this.mContactRegistered();
        } else {
          setTimeout(() => resolve(this.registerContact(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.contactLoading && !this.contactLoaded) {
          this.mContactLoading(true);
          return Contact.list(filter)
            .then((data: ListData) => {
              this.mContactLoaded(data);
              this.mContactLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredContact (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.contactLoading) {
        this.mContactLoading(true);
        return Contact.list(filter)
          .then((data: ListData) => {
            this.mContactLoaded(data);
            this.mContactLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createContact (obj: Contact): Promise<Contact> {
    return new Promise((resolve, reject) => {
      return Contact.fromJson(obj).createForStoreContact()
        .then((reccords) => {
          this.mContactCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateContact (obj: Contact): Promise<Contact> {
    return new Promise((resolve, reject) => {
      return Contact.fromJson(obj).updateForStoreContact()
        .then((reccords) => {
          this.mContactUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteContact (obj: Contact): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Contact.fromJson(obj).deleteForStoreContact()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mContactDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private contactCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mContactConfigUpdated(config)
    const obj = objConfig.obj as Contact;
    this.mContactCreated(Contact.fromJson(obj));
  }

  @Action
  private contactUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mContactConfigUpdated(config)
    const obj = objConfig.obj as Contact;
    this.mContactUpdated(Contact.fromJson(obj));
  }

  @Action
  private contactDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Contact;
    this.mContactDeleted(obj.id);
  }
}
